import { RootState } from "@/store/types";
import axios, { AxiosResponse } from "axios";
import { ActionTree } from "vuex";
import { PushDetailFilterParams, PushDetailItemInfo, PushGroupFilterParams, PushGroupItem, PushHistoryFilterParams, PushHistoryItem, PushSubscriberCountItem, StatisticState } from "./types";


export const actions: ActionTree<StatisticState, RootState> = {

  async getPushStatisticDetail({commit}, params: PushDetailFilterParams) {
    commit("setLoading", true);
    try {
      const resp = await axios({
        url: "/stats-api/detail/push",
        params: params,
      });
      let messages = resp.data?.messages ?? [];
      if (params.page_number > 1) {
        commit("pushPushStatisticDetail", messages);
      } else {
        commit("setPushStatisticDetail", messages);
      }
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async getPushStatisticDetailInfo({commit}, id: string) {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<PushDetailItemInfo> = await axios({
        url: `stats-api/detail/push/${encodeURIComponent(id)}`,
      });
      return resp.data;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async exportPushStatisticDetail({commit}, filterParams: PushDetailFilterParams) {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<{status: string}> = await axios({
        url: "/stats-api/detail/push/export",
        params: filterParams,
      });
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async resendPushMessage({commit}, id: string) {
    commit("setLoading", true);
    try {
      const resp = await axios({
        method: 'post',
        url: '/acapi/tools/push/resend',
        data: {message_ids: [id]}
      })
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },

  async getPushStatisticGroup({commit}, filterParams: PushGroupFilterParams) {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<{messages_count: number, messages: PushGroupItem[]}> = await axios({
        url: "/stats-api/group/push",
        params: filterParams,
      });
      commit("setPushStatisticGroup", resp.data.messages);
      commit('setMessagesCount', resp.data.messages_count);
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
  async exportPushStatisticGroup({commit}, filterParams: PushGroupFilterParams) {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<{status: string}> = await axios({
        url: "/stats-api/group/push/export",
        params: filterParams,
      });
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },

  async getPushSubscribersCount({commit}, filter: PushHistoryFilterParams) {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<PushSubscriberCountItem[]> = await axios({
        url: "/acapi/push/subscribers/count",
        params: filter,
      });
      commit("setPushSubscribersCount", resp.data);
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },

  async getPushHistories({commit}, filter: PushHistoryFilterParams) {
    commit("setLoading", true);
    try {
      const resp: AxiosResponse<PushHistoryItem[]> = await axios({
        url: "/acapi/push/subscribers/subscription_history",
        params: filter,
      });
      commit("setPushHistories", resp.data);
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit("setLoading", false);
    }
  },
};
